import store from "../redux/store";

export const isOrderedAssaysHasPunkts = () => {
    const {catalog, complexResearch, actions}  = store.getState().assaysCatalog;
    const {orderingList} = store.getState().orderAssays;
    const {punkts} = store.getState().collectionPoints;

    const orderedAssays = orderingList.map(currId =>
        [...catalog, ...complexResearch, ...actions].find(currAssay => +currAssay.id === +currId)
    ).reduce((acu, cur) => {
        if (cur && cur.idPunkts) {
            return [...acu, ...cur.idPunkts.map(idPunkt => punkts.find(punkt => +punkt.idPunkt === +idPunkt))];
        }
        return acu;
    }, []);

    return orderedAssays.length ? orderedAssays : false;
};
